async function RunBatch() {
   document.getElementById("btn-copy").style.display="none";
   document.getElementById("csv-results").style.diplay="none";
   document.getElementById("quick-order-form-btn").style.display = "none";
   document.getElementById("quick-order-adding").style.display = "block";
   document.getElementById("upload-form-right").style.display = "block";

    const inputText = document.getElementById('skuInputs').value;
    const CSVLines = inputText.split('\n');
    const parsedData = [];

     for (let i = 0; i < Math.min(CSVLines.length, 100); i++) {
        let HasError = false;
        let CSVLine = CSVLines[i].trim();
        if (CSVLine === '') continue;
        const parts = CSVLine.split(',');
        if (parts.length !== 2) {
            DisplayMessage(CSVLine, 'Each line must contain a comma-separated SKU and quantity.', 'Failed');
            HasError = true;
        } else {
            const sku = parts[0].trim();
            const quantity = parseInt(parts[1].trim(), 10);
            if (isNaN(quantity) || quantity < 1) {
                DisplayMessage(sku, 'Quantity must be a valid number.', 'Failed');
                HasError = true;
            }

            if (!HasError) {
                parsedData.push({ sku, quantity });
            }
        }
    }

    // Start processing the parsed data
     processParsedData(parsedData, 0);

 
      
}

          
function refreshCart(cart) {

    $cartBtn = $(".cart_button");
    if ($cartBtn) {
      var $cartCount = $cartBtn.find('.cart_count');
      if ($cartCount.length) {
        $cartCount.text(cart.item_count);
      }
    }
} 


function findProduct(productSku, quantity, callback, scannerMethod = false) {
     fetch(`/search/suggest.json?q=${encodeURIComponent(productSku)}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,variants.sku,product_type,variants.title,variants.barcode`)
        .then((response) => {
            if (!response.ok) {
                DisplayMessage(productSku, response.message, 'Failed');
               throw new Error(response.status);
            }
            return response.json();
        })
        .then((json) => {
            const products = json.resources.results.products;
            if (products.length == 0) {
                 DisplayMessage(productSku, 'Unable to look up SKU. Item may be out of stock or unavailable.', 'Failed');
                 callback(); 
              
                return;
            }

            const product = products[0];
            const productDetails = {
                handle: product.handle,
                title: product.title,
                price: product.price,
                image: product.image,
                url: product.url,
                available: product.available,
                vendor: product.vendor,
                tags: product.tags,
                description: product.body,
                variants: product.variants
            };

            var hasMedline = product.tags.includes('medline') 

            //GET MORE DETAILS. 
            fetch(`/products/${productDetails.handle}?view=quick-details`)
                .then((response) => {
                    if (!response.ok) {
                        DisplayMessage(productSku, 'Error fetching additional product details.', 'Failed');
                        throw new Error(response.status);
                    }
                    return response.json();
                })
                .then((additionalDetails) => {
                    const extractedVariant = additionalDetails.variantID;
                    const minQuantity = additionalDetails.min;
                  
                    if(quantity == null || quantity < minQuantity){
                      quantity = minQuantity;
                    }

                    if (extractedVariant == null) {
                        DisplayMessage(productSku, 'No products found for the given SKU.', 'Failed');
                        callback();
                    } else {
                        AddToCart(productSku, extractedVariant, quantity, hasMedline, callback);
                    }
                })
                .catch((error) => {
                    DisplayMessage(productSku, error.message, 'Failed');
                    callback();
                });
      })
        .catch((error) => {
            DisplayMessage(productSku, error.message, 'Failed');
            callback();
        });
}

function AddToCart(sku, variantId, qty, hasMedline, callback) {
  const timeOuts = 600;

  // Build properties object only when needed
  const properties = hasMedline ? { _medline: "true" } : undefined;

  const formData = {
    items: [
      {
        id: variantId,
        quantity: qty,
        ...(properties ? { properties } : {})
      }
    ]
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData)
  })
    .then(async (res) => {
      const data = await res.json();

      // Shopify errors often come back like: { status: 422, message: "...", description: "..." }
      if (!res.ok) {
        const msg = data?.description || data?.message || "Unable to add to cart.";
        throw new Error(msg);
      }

      DisplayMessage(sku, qty, "Success");
      setTimeout(callback, timeOuts);
      return data;
    })
    .catch((err) => {
      let errorMessage = err.message || "Unable to add to cart.";

      if (errorMessage.includes("You can't add more")) {
        errorMessage = "All available products have been added to cart.";
      }

      DisplayMessage(sku, errorMessage, "Failed");
      setTimeout(callback, timeOuts);
    });
}

function DisplayMessage(sku, MessageText, status) {
    const outputDiv = document.getElementById('output-info');
    const outCSV = document.getElementById('csv-results');
    //outCSV.style.display = "block";
    let icon = "qf-success";

    if(status == "Failed")
    {
       icon = "qf-failed"
    }

    outputDiv.innerHTML += '<li class="output-info-' + status + '"><span class="'+icon+'"> '+ status + '</span> ' + sku + ', ' + MessageText + '</li>';
    outCSV.value += status + "," + sku + "," + MessageText + "\n";
}

function copyToClipboard() {
    const textArea = document.getElementById('csv-results');
    textArea.select();
    document.execCommand('copy');
    alert('CSV content copied to clipboard');
}



function processParsedData(parsedData, index) {
    if (index >= parsedData.length) {
        document.getElementById("quick-order-form-btn").style.display = "block";
        document.getElementById("quick-order-adding").style.display = "none";
      
        document.getElementById("btn-copy").style.display="none";
        document.getElementById('skuInputs').value = "";
       
        $.getJSON("/cart.js", function(cart) {
            refreshCart(cart);
          });
        
        
       return;
    }

    const { sku, quantity } = parsedData[index];
    findProduct(sku, quantity, function() {
        processParsedData(parsedData, index + 1);
    });
}

//UPLOAD CSV
window.onload = function () {
    const form = document.getElementById('csvForm');

    form.addEventListener('submit', async (e) => {
        document.getElementById("upload-form-right").style.display = "block";
        document.getElementById("upload-csv-button").style.display = "none";
        document.getElementById("csv-order-process").style.display = "block";


            // Only scroll on mobile (e.g. <= 768px wide)
            const isMobile = window.matchMedia('(max-width: 768px)').matches;
            if (isMobile) {
                setTimeout(() => {
                    document.getElementById('scroll-upload-to').scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 300);
            }


        e.preventDefault();

        const fd = new FormData(e.target);
    
        let data;
        try {
            const res = await fetch('/apps/csv-upload', { method: 'POST', body: fd });
       
            if (!res.ok) {
                const text = await res.text();
                console.error('Upload failed:', text);
                alert('Upload failed. Please try again.');
                return;
            }
            data = await res.json(); // [{ sku, quantity, id, error }]
        } catch (err) {
            console.error('Network error:', err);
            alert('Network error. Please try again.');
            return;
        }

        // Process each line sequentially

        let index = 0;

        function processNext() {
        if (index >= data.length) {
        document.getElementById("upload-csv-button").style.display = "block";
        document.getElementById("csv-order-process").style.display = "none";
        $.getJSON("/cart.js", function(cart) {
            refreshCart(cart);
        });
        return;
        }

        const line = data[index++];
        const sku = line.sku;
        const qty = line.quantity;
        const variantId = line.id;
        const error = line.error;
        const IsMedline = line.IsMedline;

        if (!variantId || error) {
        DisplayMessage(sku, error || "SKU not found or unavailable", "Failed");
        processNext();
        return;
        }

        AddToCart(sku, variantId, qty, IsMedline, processNext);
        }

        processNext();
    });
};